import { Element, Image } from '@zmedia/bm-soccer-ui/components';
import { memo, useState } from 'react';
import styles from './style.module.scss';

const DEFAULT_AVATAR =
    'https://znews-photo.zingcdn.me/w360/Uploaded/yuiikx/player/nofoto_jugador.png';
interface IProps {
    avatar?: string;
    name?: string;
    children?: React.ReactNode;
}
export function Avatar({ avatar = DEFAULT_AVATAR, children, name }: IProps) {
    const [src, setSrc] = useState<string>(avatar);
    return (
        <Element className={styles['avatar-container']}>
            <Image
                className={styles['avatar']}
                alt={'Cầu thủ ' +name || 'avatar'}
                src={src}
                onError={() => setSrc(DEFAULT_AVATAR)}
            />
            {children}
        </Element>
    );
}

export default memo(Avatar);
